import React from 'react';
import '../assets/css/style.css';
import img1 from '../assets/css/img/sidbi.png';
import img2 from '../assets/css/img/sbi.png';
import img3 from '../assets/css/img/union.png';
import img4 from '../assets/css/img/pnb.png';
import img5 from '../assets/css/img/ecofy.png';
import img6 from '../assets/css/img/yesbank.png';
import shock from '../assets/css/img/shock2.png';

const Partners = () => {
    const partners = [
        { name: 'SIDBI', src: img1 },
        { name: 'SBI', src: img2 },
        { name: 'Union Bank', src: img3 },
        { name: 'PNB', src: img4 },
        { name: 'Ecofy', src: img5 },
        { name: 'Yes Bank', src: img6 },
    ];

    return (
        <div className="partners-section text-center"> {/* Center content */}
            <h1 className="ps-5 white-heading text-center">
                <img src={shock} className="shock2" alt="shock-icon" />&nbsp;Our Partners
            </h1>

            <div className="container">
                <div className="row justify-content-center"> {/* Center row within the container */}
                    {partners.map((partner, index) => (
                        <div key={index} className="col-lg-4 col-mb-3"> {/* 4 columns per row (3 cards) */}
                            <div className="cards partner-card h-100"> {/* h-100 ensures cards have equal height */}
                                <img src={partner.src} className="card-img-top" alt={partner.name} />
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
}

export default Partners;
